export default __webpack_public_path__ + "static/media/check.54fd7f44.svg";